var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',{staticClass:"full-width-mobile-padding breadcrumbs-container",attrs:{"cols":"12"}},[_c('CBreadcrumbs',{attrs:{"nuxt-links":_vm.nuxtLinks,"breadcrumbs":_vm.breadcrumbs}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }